import { useEffect, useState } from "react";
import { LoadingScreen } from "@/components/ui/LoadingScreen";
import { Unauthorized } from "@/components/ui/Unauthorized";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

const withFeatureFlagRequired = <P extends object>(
  featureFlagName: string,
  WrappedComponent: React.ComponentType<P>
) => {
  const ProtectedComponent = (props: P) => {
    const [loading, setLoading] = useState(true);
    const isEnabled = useFeatureFlag(featureFlagName);

    useEffect(() => {
      setLoading(false);
    }, [isEnabled]);

    if (loading) {
      return <LoadingScreen fullPage={false} />;
    }

    return isEnabled ? (
      <WrappedComponent {...props} />
    ) : (
      <Unauthorized message={`This feature is not enabled yet.`} />
    );
  };

  return ProtectedComponent;
};

export default withFeatureFlagRequired;
